backgroundStyleProp = require 'utils/background-style-prop'

###
# Модель темы
###
App.Theme = DS.Model.extend
  name:         DS.attr 'string'
  title:        DS.attr 'string'
  description:  DS.attr 'string'
  thumbnail:    DS.attr 'mixed'
  options:      DS.attr 'mixed'

  thumbnailMediumBackground: backgroundStyleProp('thumbnail.medium')

# App.ThemeAdapter = DS.FixtureAdapter.extend()

App.Theme.FIXTURES =
[
  id: 1
  name:         'standard'
  title:        'Стандартная тема'
  description:  'Эту тему мы советуем поставить по-умолчанию'
  thumbnail:    { normal: 'http://www.wpexplorer.com/wp-content/uploads/earth-wordpress-theme1.png' }
  options:
    [
      name: 'param-1',
      type: 'select',
      text: 'Цвет',
      values:
        [
          name: 'black', value: 'Черный'
        ,
          name: 'white', value: 'Белый'
        ,
          name: 'green', value: 'Зеленый'
        ]
    ,
      name: 'param-2',
      type: 'toggle',
      text: 'Авиарежим',
      values: []
    ,
      name: 'param-3',
      type: 'text',
      text: 'Девиз ресторана',
      values: []
    ,
      name: 'param-4',
      type: 'image',
      text: 'Фон шапки сайта',
      values: []
    ,
      name: 'param-5',
      type: 'color',
      text: 'Цвет',
      values:[]
    ]
,
  id: 2
  name:         'liquid'
  title:        'Современная тема'
  description:  'Современная нескучная тема. Почему она жидкая, мы сами не знаем.'
  thumbnail:    { normal: 'http://cdn.ourtutscom.netdna-cdn.com/wp-content/uploads/2013/04/liquid-folio-wordpress-theme.jpg' }
  options:      []
,
  id: 3
  name:         'solid'
  title:        'Классическая тема'
  description:  'Тема подойдет романтикам.'
  thumbnail:    { normal: 'http://www.wpexplorer.com/wp-content/uploads/metrovibes-metro-wordpress-theme.png' }
  options:      []
]

